import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'read-only-text',
  templateUrl: './read-only-text.component.html',
  standalone: false,
})
export class ReadOnlyTextComponent {
  @Input() shouldTranslate = false;
  @Input() val: number | string | undefined;
  @Input() shouldShowDelete: boolean | undefined;
  @Input() hasLeftSpacing = true;
  @Input() isPending = false;

  @Output() public readonly deleteClicked = new EventEmitter();

  emit(): void {
    this.deleteClicked.emit();
  }
}
